import { render, staticRenderFns } from "./CenterIndex.vue?vue&type=template&id=410ba2e8&scoped=true"
import script from "./CenterIndex.vue?vue&type=script&lang=js"
export * from "./CenterIndex.vue?vue&type=script&lang=js"
import style0 from "./CenterIndex.vue?vue&type=style&index=0&id=410ba2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410ba2e8",
  null
  
)

export default component.exports